/** @jsxImportSource @emotion/react */
"use client";
import { matchSelectableGuide } from "@packages/media";
import type { SelectableGuide } from "@packages/sdk";
import { ModalDropdownMenuItem } from "@packages/ui";
import { HallowDataTestId } from "@tools/playwright/global";
import { useHover } from "react-aria";

import { GuideInfo } from "../../data/GuideInfo.emotion";

export type SelectGuideListProps = {
  selectedGuides: number[] | undefined;
  onGuideSelection: (guides: number[]) => void;
  options: SelectableGuide[];
};

const InternalSelectableGuideModalDropdownMenuItem = ({
  guide,
  onSelect,
  selected,
}: {
  guide: SelectableGuide;
  onSelect: () => void;
  selected: boolean;
}) => {
  const { hoverProps, isHovered } = useHover({});

  return (
    <div {...hoverProps}>
      <ModalDropdownMenuItem
        {...hoverProps}
        data-testid={HallowDataTestId.MediaGuideOption}
        data-guide={guide.name}
        onSelect={onSelect}
        selected={selected}
      >
        <GuideInfo guide={guide} isHovered={isHovered} />
      </ModalDropdownMenuItem>
    </div>
  );
};

export const SelectGuideList = ({
  options,
  selectedGuides,
  onGuideSelection,
}: SelectGuideListProps) => (
  <>
    {(options ?? []).map((option) => (
      <InternalSelectableGuideModalDropdownMenuItem
        key={`sessionDetails_selectGuide_guide_${option.name}`}
        guide={option}
        onSelect={() => onGuideSelection(option.guide_ids)}
        selected={matchSelectableGuide(option.guide_ids, selectedGuides)}
      />
    ))}
  </>
);
